import React, { useState, useEffect } from "react";
import "./notifications.css";
import Notification from "../notification";
import { baseRequest } from "../../../axiosconfig";

function Notifications(props) {
  const [activeSortValue, setActiveSortValue] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [notificationsList, setNotificationsList] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    setError("");
    baseRequest
      .get("/notifications")
      .then((res) => {
        const rows = (res.data.notifications || []).map((n) => ({
          id: n.id,
          date: new Date(n.created_at).toLocaleDateString("sr-RS"),
          message: n.message,
          target_url: n.target_url,
        }));
        setNotificationsList(rows);
      })
      .catch(() => {
        setNotificationsList([]);
        setError("Učitavanje obaveštenja nije uspelo.");
      });
  }, []);

  const sortedList = [...notificationsList].sort((a, b) => {
    if (activeSortValue === "Najstarije") return a.id - b.id;
    return b.id - a.id;
  });
  return (
    <div className="notifications">
      <div className="notifications-header">
        <div className="sort-options-dropdown">
          <div
            className="sort-options-dropdown-selected"
            onClick={() => {
              setShowDropdown((state) => !state);
            }}
          >
            <span>Sortiraj po:</span>
            <span style={{ fontWeight: "bold", margin: "0 10px 0 5px" }}>
              {activeSortValue}
            </span>

            <img
              src="/images/sidebararrow.png"
              className="sidebar-navigation-item-arrow"
            ></img>
          </div>
          {showDropdown && (
            <ul className="sort-options-dropdown-options">
              <li
                className="sort-options-dropdown-options-item"
                onClick={() => {
                  setActiveSortValue("Najnovije");
                  setShowDropdown(false);
                }}
              >
                Najnovije
              </li>
              <li
                className="sort-options-dropdown-options-item"
                onClick={() => {
                  setActiveSortValue("Najstarije");
                  setShowDropdown(false);
                }}
              >
                Najstarije
              </li>
              <li
                className="sort-options-dropdown-options-item"
                onClick={() => {
                  setActiveSortValue("Najbolje");
                  setShowDropdown(false);
                }}
              >
                Najbolje
              </li>
            </ul>
          )}
        </div>
      </div>
      <ul>
        {sortedList.length === 0 && (
          <li style={{ padding: "20px", color: "var(--mainColor)" }}>
            {error || "Nema obaveštenja."}
          </li>
        )}
        {sortedList.map((notification) => {
          return (
            <Notification key={notification.id} notification={notification} />
          );
        })}
      </ul>
    </div>
  );
}

export default Notifications;
